import { Injectable } from "@angular/core";
import { TinyMCE } from "tinymce";
declare type EditorOptions = Parameters<TinyMCE["init"]>[0];

@Injectable({ providedIn: "root" })
export class TinyService {
  constructor() {}

  public modules(): EditorOptions {
    return {
      plugins: "link code image fullscreen template table",
      menubar: false,
      templates: this.getTemplates(),
      link_list: async (success: any) => {
        const pages = await this.getLinkList();
        console.log(pages);
        success(pages);
      },
      content_langs: [
        { title: "Čeština", code: "cs" },
        { title: "English", code: "en" },
      ],
      branding: false,
      language_url: "/assets/js/cs.js",
      toolbar:
        "undo redo | bold italic underline | blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist table | forecolor casechange permanentpen formatpainter removeformat hr | image template link | fullscreen code",
    };
  }

  public modulesEasy(height = 240): EditorOptions {
    return {
      plugins: "link table",
      menubar: false,
      branding: false,
      height,
      toolbar:
        "bold italic underline | link | alignleft aligncenter alignright alignjustify  | numlist bullist checklist",
    };
  }

  public modulesCopyright(height = 130): EditorOptions {
    return {
      plugins: "link table",
      menubar: false,
      branding: false,
      height,
      toolbar:
        "bold italic underline | link",
    };
  }

  public modulesText(): EditorOptions {
    return {
      plugins: "",
      menubar: false,
      toolbar: "undo redo | bold italic underline | blocks |",
      branding: false,
    };
  }

  public modulesFull(): EditorOptions {
    return {
      plugins: "link",
      menubar: false,
      toolbar:
        "undo redo | bold italic underline | link | blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist table | forecolor casechange permanentpen formatpainter removeformat hr",
      branding: false,
    };
  }

  getTemplates(): unknown {
    return [
      {
        title: "Ukazková tailwind template",
        description: "Toto je ukázkový template.",
        content:
          '<div class="flex items-stretch"><div class="w-1/3">1</div><div class="w-1/3">2</div><div class="w-1/3">3</div></div>',
      },
    ];
  }

  async getLinkList(): Promise<void> {
    // console.log('getting links');
    // const pages = await this.adminService.pageControllerAdminGetAllPageEntities().toPromise();
    // return pages;
    // return [
    //   {title: 'Tiny Home Page', value: 'https://www.tiny.cloud'},
    //   {title: 'Tiny Blog', value: 'https://www.tiny.cloud/blog'},
    //   {title: 'TinyMCE Documentation', value: 'https://www.tiny.cloud/docs/'},
    //   {title: 'TinyMCE on Stack Overflow', value: 'https://stackoverflow.com/questions/tagged/tinymce'},
    //   {title: 'TinyMCE GitHub', value: 'https://github.com/tinymce/'}
    // ]
  }
  imageUpload(blobInfo: any): void {
    // const file = blobInfo.blob();
    // console.log(file);
    // const filePath = `${Date.now()}-${blobInfo.filename()}`;
    // const promise = new Promise<string>(async (resolve, reject) => {
    //   try {
    //     const result = await this.adminService.assetManagerControllerAdminUploadAsset(file).toPromise();
    //     if(result?.filename && result?.url) {
    //       resolve(result.url);
    //       // this.snackBar.open("Uspěšně uloženo", "OK", {duration: 2000});
    //     }
    //   } catch (e) {
    //     reject(e);
    //   }
    // });
    // return promise;
  }
}
